import { useLayoutEffect, useState } from 'react';
import routes from '../defaultLayout/routes';
import './navBar.scss';

const NavBar = () => {
    const [currentPath, setCurrentPath] = useState('');
    const height = window.innerHeight;

    useLayoutEffect(() => {
        // eslint-disable-next-line no-restricted-globals
        setCurrentPath(location.pathname);
    }, []);

    const onClickHandler = (path: string) => {
        window.location.href = path
    };

    return (
        <div id="nav_bar" style={{ minHeight: height }}>
            <div className="title">Pages</div>
            <div className="nav_wrapper">
                {routes.map((route) => {
                    const { name, path } = route;
                    if (path.length < 2) return undefined; // skip this one
                    if (path === '/reportTestPage') return null
                    return (
                        <span
                            key={name}
                            className={`nav_item${path === currentPath ? ' active' : ''}`}
                            onClick={() => onClickHandler(path)}
                        >
                            {name}
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

export default NavBar;
